import IncomeConcentrationBanner from '@/components/IncomeConcentrationBanner';
import AdrTaxDragBanner from '@/components/AdrTaxDragBanner';
import usePortfolioContrastRows from '@/hooks/usePortfolioContrastRows';

// Per-portfolio risk banners (income concentration + ADR tax drag)
// rendered under Benchmark Comparison, above the dividend cut/raise
// banners in PortfolioView. Sep 2026 — moved out of the retired
// Income by Portfolio card.
export default function PortfolioRiskBanners({ onStockClick }) {
  const { rows, loaded } = usePortfolioContrastRows();
  if (!loaded || rows.length === 0) return null;
  return (
    <div data-testid="portfolio-risk-banners">
      {rows.map((row) => (
        <div key={row.portfolio_id || 'untagged'} data-testid={`risk-banners-${row.portfolio_id || 'untagged'}`}>
          <IncomeConcentrationBanner
            portfolioId={row.portfolio_id || null}
            riskData={row.concentration}
            onStockClick={onStockClick}
          />
          {row.adr_tax_drag && (
            <div className="mb-3">
              <AdrTaxDragBanner taxDrag={row.adr_tax_drag} onStockClick={onStockClick} />
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
